import { createFileRoute } from "@tanstack/react-router";
import { CallLogScreen } from "../components/relations/CallLogScreen";

export const Route = createFileRoute("/_auth/relations/log")({
  staticData: {
    titleKey: "relations.callLog.title",
    breadcrumbKey: "breadcrumb.operate",
    breadcrumbN: 7,
  },
  component: CallLogScreen,
});
